/* src/app/shared/contract/contract-item/contract-natio-nego/natio-nego-condition-dynamic/natio-nego-condition-dynamic.component.scss */
:host {
  display: flex;
  min-width: 0;
}
:host > form {
  display: flex;
  flex: 1;
  min-width: 0;
}
.condition-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  margin-bottom: 0;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.inputs-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr)) auto auto;
  align-items: center;
  gap: 10px;
}
.inputs-container > .tv-container-select-white-rect-extensible,
.inputs-container > .tv-rect-input-extensible {
  min-width: 0;
  width: 100%;
}
.inputs-container > .tv-container-select-white-rect-extensible mat-form-field,
.inputs-container > .tv-rect-input-extensible mat-form-field {
  width: 100%;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.condition-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
}
.condition-header .red-title {
  flex-shrink: 0;
  margin: 0;
}
.condition-header-separator {
  flex-shrink: 0;
  width: 1px;
  height: 20px;
  margin: 0 10px;
  background-color: #DFEBF7;
}
.condition-category-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #F03C64;
  font: 400 12px FranceTV Brown;
}
.condition-category-info mat-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
.content-position {
  align-items: center;
}
.svg-delete-icon {
  width: 50px;
  height: 50px;
  border: red 10px;
}
.conditions-table-container {
  background-color: #FFF;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #DFEBF7;
}
.conditions-table-scroll {
  --condition-table-header-height: 36px;
  --condition-table-row-height: 32px;
  height: calc(var(--condition-table-header-height) + 2 * var(--condition-table-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.conditions-table {
  width: 100%;
  table-layout: fixed;
}
.conditions-table .mat-mdc-header-row {
  height: var(--condition-table-header-height);
}
.conditions-table .mat-mdc-row {
  height: var(--condition-table-row-height);
}
.conditions-table .mat-mdc-header-cell,
.conditions-table .mat-mdc-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.conditions-table .mat-column-category {
  width: 27%;
}
.conditions-table .mat-column-number {
  width: 96px;
}
.conditions-table .mat-column-remove {
  width: 56px;
}
.condition-remove-icon {
  color: #0083FF;
}
.condition-remove-button-wrapper {
  display: inline-flex;
  vertical-align: middle;
}
.conditions-table .tv-icon-button-s-transparent:disabled {
  pointer-events: none;
  cursor: default;
}
.conditions-table .tv-icon-button-s-transparent:disabled .condition-remove-icon {
  opacity: 0.4;
}
.condition-cell-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=natio-nego-condition-dynamic.component.css.map */
